var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7053_5798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2726 19.2174L15.4888 13.4336C14.9823 14.1849 14.3282 14.8254 13.5664 15.3163L19.3702 21.1197V21.1198C19.7102 21.4589 20.205 21.591 20.6689 21.4666C21.1327 21.342 21.4951 20.9798 21.6194 20.516C21.744 20.0522 21.6118 19.5572 21.2727 19.2172L21.2726 19.2174Z",
    fill: "#7872B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0014 12.4824C16.1034 10.8391 16.5568 8.84554 16.2741 6.88726C15.9913 4.92898 14.9924 3.14501 13.4705 1.88055C11.9487 0.61623 10.012 -0.0390524 8.03506 0.0418447C6.05815 0.122723 4.1815 0.933749 2.76791 2.31826C1.35429 3.70277 0.50425 5.56217 0.382405 7.53701C0.260414 9.51196 0.875164 11.462 2.10767 13.0097C3.34018 14.5574 5.10283 15.5934 7.05485 15.9167C9.00683 16.2402 11.0094 15.8284 12.6754 14.7607C13.5971 14.1668 14.3887 13.3917 15.0016 12.4824L15.0014 12.4824ZM11.301 13.3868C9.55098 14.3483 7.44247 14.398 5.64898 13.52C3.85557 12.642 2.60162 10.9462 2.28771 8.97429C1.97381 7.00233 2.63928 5.00088 4.07137 3.60957C5.50343 2.21815 7.5231 1.61077 9.48526 1.98122C11.4473 2.35184 13.1063 3.65413 13.9323 5.47197C14.7583 7.28997 14.6479 9.39621 13.6364 11.1179C13.0786 12.0725 12.2712 12.8571 11.3009 13.3871L11.301 13.3868Z",
    fill: "#7872B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7053_5798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3d4b07b595de770bc42a0b351497e774.svg";
export { ForwardRef as ReactComponent };